import {
  AppContext,
  getTranslatedText,
  useActivityTracker,
  GET_CONSTANTS
} from '@nile/components';
import ErrorPage from '@nile/components/src/Components/ErrorPage';
import {
  AccountClient,
  GET_ALL_ACTIVE_ADDONS,
  GET_CUSTOMER_SUBSCRIPTION
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { AddTechEndpoint } from '@nile/banyan/src/Pages/Protected/Configuration/Pricing';
import ContactVendorModal from './ContactVendorButton';

const BuyAddonButton = (props) => {
  const intl = useIntl();
  const { activator, isOpen, closeWindow } = props;
  const [addOnList, setAddOnList] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);

  const [currency, setCurrency] = useState('USD');
  const [tenure, setTenure] = useState('YEARLY');
  const [locale, setLocale] = useState('en-US');

  const [openBuyAddon, setOpenBuyAddon] = useState(false);

  const appContext = useContext(AppContext);
  const { user, currentLanguage, isSuperopsUser, isTrialUser } = appContext;

  const getCountryList = async () => {
    try {
      const country = await GET_CONSTANTS('country');
      return country;
    } catch {
      // error
    }
  };

  const getAllAddons = () => {
    AccountClient.query({
      query: GET_ALL_ACTIVE_ADDONS,
      fetchPolicy: 'network-only'
    }).then((res) => {
      if (res?.data?.getAllActiveAddons) {
        setAddOnList(res.data.getAllActiveAddons);
      }
    });
  };

  const getCustomerSubscription = () => {
    AccountClient.query({
      query: GET_CUSTOMER_SUBSCRIPTION,
      fetchPolicy: 'network-only'
    })
      .then(async (res) => {
        if (res?.data?.getCustomerSubscription) {
          setCurrentSubscription(res.data.getCustomerSubscription);
          setTenure(
            res.data.getCustomerSubscription?.currentPlanPrice?.duration ||
              'YEARLY'
          );
          if (
            res.data.getCustomerSubscription?.currentPlanPrice?.currency
              ?.currencyCode
          ) {
            const curr =
              res.data.getCustomerSubscription.currentPlanPrice.currency;
            setCurrency(curr.currencyCode || 'USD');
            const countryList = await getCountryList();
            setLocale(
              countryList?.filter(
                (country) => country.currency === curr.currencyCode
              )?.[0]?.isoCode
                ? `${currentLanguage.value || 'en'}-${
                    countryList?.filter(
                      (country) => country.currency === curr.currencyCode
                    )?.[0]?.isoCode
                  }`
                : 'en-US'
            );
          }
        }
      })
      .finally(() => {});
  };

  useEffect(() => {
    getAllAddons();
    if (!isTrialUser) {
      getCustomerSubscription();
    }
  }, []);

  const renderMessage = !user?.subscriptionStatus;

  if (renderMessage) {
    return (
      <ErrorPage
        imageURL={`url(${envConfig.imageRoot}svg/PageNotFound.svg)`}
        text="Purchase plan"
        description={getTranslatedText(intl, 'pricing.buy.plan.trail')}
        // link="#/pricing"
        showBtn
      />
    );
  }

  return (
    <>
      {activator ? (
        <>{activator}</>
      ) : (
        <button
          className="Superops-buy-addon-Button"
          onClick={() => {
            useActivityTracker({
              event: `Inproduct purchase - addon - ${props.feature ||
                'Timesheet'}`
            });
            setOpenBuyAddon(true);
          }}
        >
          <FormattedMessage id="admin.billing.buyAddon" />
        </button>
      )}
      {isSuperopsUser ? (
        <AddTechEndpoint
          active={activator ? isOpen : openBuyAddon}
          handleClose={() => {
            if (activator) {
              closeWindow(false);
            } else {
              setOpenBuyAddon(false);
            }
          }}
          subscription={currentSubscription}
          plan={currentSubscription?.currentPlanPrice?.plan}
          getCustomerSubscription={getCustomerSubscription}
          tenure={tenure}
          currency={currency}
          locale={locale}
          addOnList={addOnList}
          intl={intl}
          setTenure={setTenure}
        />
      ) : (
        <ContactVendorModal
          active={activator ? isOpen : openBuyAddon}
          handleClose={() => {
            if (activator) {
              closeWindow(false);
            } else {
              setOpenBuyAddon(false);
            }
          }}
        />
      )}
    </>
  );
};

export default BuyAddonButton;
